import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSendFormMutation, usePingQuery } from "../../redux/services/crmAPI";
import "./login.scss";

const Login = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [singIn, { error }] = useSendFormMutation();
    const { refetch: refetchPing } = usePingQuery("ping");

    useEffect(() => {
        if (error?.status === 418) {
            alert("Логін або пароль введені невірно");
        }
    }, [error]);

    const sendFormHandler = async () => {
        const formData = {
            email: email,
            password: password,
        };

        console.log(formData);

        await singIn({ body: formData, url: "sign-in" }).unwrap();
        await refetchPing();
        navigate("/");
    };

    return (
        <div className="container-fluid">
            <div className="col-12 col-sm-6 col-md-5 center_block">
                <div className="login__form">
                    <div className="text-center">
                        <img src={require("../../images/logo_warehouse.png")} className="logo_warehouse" />
                    </div>
                    <div className="mx-20">
                        <div className="mb-3">
                            <input
                                type="email"
                                placeholder="Email"
                                className="form-control no-border"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className="mb-3">
                            <input
                                type="password"
                                placeholder="Пароль"
                                className="form-control no-border"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        <div className="mb-3 d-grid gap-2">
                            <button className="btn btn-primary btn-block btn-lg" onClick={sendFormHandler}>
                                Авторизація
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
